import React from 'react';
import BookingCard from './BookingCard';
import CalendarLegend from './CalendarLegend';
import LoadingSpinner from '../common/LoadingSpinner';

const wwooferInitiatedEnabled = window.wwoofBooking?.settings?.wwooferInitiatedEnabled || false;

const BookingList = ({ 
  bookings, 
  loading, 
  actionLoading, 
  onEditDates, 
  onCancel, 
  onAccept,
  currentUserId,
  selectedStatuses,
  onStatusChange
}) => {
  if (loading) {
    return <LoadingSpinner message='Loading bookings...' />;
  }

  return (
    <>
      <CalendarLegend
        wwooferInitiatedEnabled={wwooferInitiatedEnabled}
        selectedStatuses={selectedStatuses}
        onStatusChange={onStatusChange}
      />
      {bookings.length === 0 ? (
        <LoadingSpinner message='No bookings found.' />
      ) : (
        <div className='bookings-list'>
          {bookings.map(booking => (
            <BookingCard
              key={booking.id}
              booking={booking}
              actionLoading={actionLoading}
              onEditDates={onEditDates}
              onCancel={onCancel}
              onAccept={onAccept}
              currentUserId={currentUserId}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default BookingList;
